var _path, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_photo_alternate_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.259,
    height: 54.259,
    viewBox: "0 0 54.259 54.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M0,0H54.259V54.259H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-button",
    transform: "translate(6.398 6.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104565",
    "data-name": "Group 104565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64211",
    "data-name": "Path 64211",
    d: "M20.73,0a20.73,20.73,0,1,0,20.73,20.73A20.73,20.73,0,0,0,20.73,0Zm8.73,21.391a1.481,1.481,0,0,1-.665.665v.007L16.95,27.986a1.481,1.481,0,0,1-2.143-1.333V14.808a1.481,1.481,0,0,1,2.143-1.325L28.8,19.405A1.481,1.481,0,0,1,29.461,21.391Z",
    fill: "#828282"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.5bc3a2ff13dc0d32a44c17e792431a18.svg";
export { ForwardRef as ReactComponent };